import { characters } from "@/mocks/characters";
import { settingEntries } from "@/mocks/settings";

export function CharacterPreview() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex items-center justify-between">
          <div>
            <span className="inline-flex rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800 whitespace-nowrap">
              角色档案
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              认识杂货铺里的他们
            </h2>
          </div>
          <a
            href="/characters"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
          >
            完整图鉴
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((char) => (
            <a
              key={char.id}
              href="/characters"
              className="group overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={char.image}
                  alt={`${char.name}角色插画`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
                    char.accent === "primary"
                      ? "bg-primary-500"
                      : char.accent === "accent"
                      ? "bg-accent-500"
                      : "bg-secondary-500"
                  }`}
                >
                  {char.trait}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  {char.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-600">{char.role}</p>
                <p className="mt-2 text-xs leading-5 text-foreground-700 line-clamp-2">
                  {char.tagline}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SettingPreview() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex items-center justify-between">
          <div>
            <span className="inline-flex rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900 whitespace-nowrap">
              设定百科
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              需要时随手一查的设定辞条
            </h2>
          </div>
          <a
            href="/settings"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
          >
            进入百科
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {settingEntries.map((entry) => (
            <a
              key={entry.id}
              href="/settings"
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-100/70 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="h-36 w-full overflow-hidden">
                <img
                  src={entry.image}
                  alt={entry.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-medium text-accent-700">{entry.category}</span>
                <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-950">
                  {entry.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">
                  {entry.summary}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}